export const COMPLETE_CATEGORY_PDF_SLOT = '__complete_category_pdf__';

export const DOC_CATEGORIES = [
  {
    key: 'student_kyc', label: 'Student KYC',
    slots: [
      { key: 'aadhar_front', label: 'Aadhar Front' },
      { key: 'aadhar_back', label: 'Aadhar Back' },
      { key: 'pan', label: 'PAN Card' },
      { key: 'passport', label: 'Passport' },
      { key: 'photo', label: 'Passport Photo' },
    ],
  },
  {
    key: 'academic_memos', label: 'Academic Memos',
    slots: [
      { key: 'semester_1', label: 'Semester 1' },
      { key: 'semester_2', label: 'Semester 2' },
      { key: 'semester_3', label: 'Semester 3' },
      { key: 'semester_4', label: 'Semester 4' },
      { key: 'semester_5', label: 'Semester 5' },
      { key: 'semester_6', label: 'Semester 6' },
      { key: 'semester_7', label: 'Semester 7' },
      { key: 'semester_8', label: 'Semester 8' },
    ],
  },
  {
    key: 'semester_memos', label: 'Semester Memos',
    slots: [
      { key: 'sem_memo_1', label: 'Semester Memo 1' },
    ],
    isAddable: true,
    slotPrefix: 'sem_memo_',
    slotLabelPrefix: 'Semester Memo ',
  },
  {
    key: 'admission_tests', label: 'Admission & Tests',
    slots: [
      { key: 'offer_letter', label: 'Offer Letter' },
      { key: 'ielts_toefl_gre', label: 'IELTS / TOEFL / GRE' },
    ],
  },
  {
    key: 'financial_docs', label: 'Financial Documents',
    slots: [
      { key: 'experience_letter', label: 'Experience Letter' },
      { key: 'bank_statement_6m', label: '6 Month Bank Statement' },
    ],
  },
  {
    key: 'agriculture_income', label: 'Agriculture Income',
    slots: [
      { key: 'agri_income', label: 'Agri Income' },
      { key: 'patta_passbook', label: 'Patta Passbook' },
    ],
  },
  {
    key: 'co_applicant', label: 'Co-Applicant KYC',
    slots: [
      { key: 'co_aadhar_front', label: 'Aadhar Front' },
      { key: 'co_aadhar_back', label: 'Aadhar Back' },
      { key: 'co_pan', label: 'PAN Card' },
      { key: 'co_photo', label: 'Photo' },
    ],
  },
  {
    key: 'business_docs', label: 'Business Documents',
    slots: [
      { key: 'itr', label: 'ITR' },
      { key: 'business_proof', label: 'Business Proof' },
    ],
  },
  {
    key: 'salary_docs', label: 'Salary Documents',
    slots: [
      { key: 'salary_bank_statement', label: '6 Months Bank Statement' },
      { key: 'salary_slips', label: 'Salary Slips' },
    ],
  },
  {
    key: 'house_proof', label: 'House Proof',
    slots: [
      { key: 'house_tax', label: 'House Tax' },
      { key: 'current_bill', label: 'Current Bill' },
    ],
  },
  {
    key: 'cheques', label: 'Security Cheques',
    slots: [
      { key: 'cheque_1', label: 'Cheque 1' },
      { key: 'cheque_2', label: 'Cheque 2' },
      { key: 'cheque_3', label: 'Cheque 3' },
      { key: 'cheque_4', label: 'Cheque 4' },
      { key: 'cheque_5', label: 'Cheque 5' },
      { key: 'cheque_6', label: 'Cheque 6' },
      { key: 'cheque_7', label: 'Cheque 7' },
      { key: 'cheque_8', label: 'Cheque 8' },
    ],
  },
  {
    key: 'extra_documents', label: 'Extra Documents',
    slots: [],
    isDynamic: true,
  },
];
